export default "__VITE_ASSET__ec5a1cdc__"